import { render, staticRenderFns } from "./NotificationTab.vue?vue&type=template&id=3ea22ca4&scoped=true&"
import script from "./NotificationTab.vue?vue&type=script&lang=js&"
export * from "./NotificationTab.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTab.vue?vue&type=style&index=0&id=3ea22ca4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea22ca4",
  null
  
)

export default component.exports